import { useNavigate, useMatches } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu } from "@mui/icons-material";
import css from "./LayoutBar.module.css";
import layoutBarApplicationLogo from "/unruly-logo-color-nobg-rect.png";
import { usePageTitle } from "../../context/usePageTitle";
import { RouteHandle } from "../../type/enum";

const LayoutBar = () => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const { title, subtitle } = usePageTitle();

  // Scroll detection
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Get the current page name from route handles
  const matches = useMatches();
  const getPageName = (matches: ReturnType<typeof useMatches>) => {
    const currentMatch = matches[matches.length - 1];
    const handle = currentMatch?.handle as RouteHandle;
    return handle?.pageTitle || "";
  };

  const currentPage = getPageName(matches);

  const toggleSidebar = () => {
    // Dispatch custom event to communicate with Sidebar component
    window.dispatchEvent(
      new CustomEvent("mobileSidebarToggle", {
        detail: {},
      }),
    );
  };

  const handleLogoClick = () => {
    navigate("/");
  };

  return (
    <div className={css.layoutBar}>
      <button
        className={css.mobileToggle}
        onClick={toggleSidebar}
        aria-label="Toggle Sidebar"
      >
        <Menu />
      </button>
      <div className={css.logoSection}>
        <img
          src={layoutBarApplicationLogo}
          className={css.logo}
          alt="Unruly Logo"
          onClick={handleLogoClick}
          style={{ cursor: "pointer" }}
        />
      </div>
      <div className={css.pageInfo}>
        <div className={css.pageName}>{currentPage}</div>
        {isScrolled && title && (
          <div className={css.pageTitleSection}>
            <div className={css.pageTitle}>{title}</div>
            {subtitle && <div className={css.pageSubtitle}>{subtitle}</div>}
          </div>
        )}
      </div>
    </div>
  );
};

export default LayoutBar;
